const t = "DD";//transparencia
export const darkColors = [
    '#FF1111'+t,//no iniciado		rojo
    '#FFEA00'+t,//pend. cargador	amarillo
    '#FF9100'+t,//pend. sup. carga	naranja
    '#40C4FF'+t,//pend. codificador	celeste claro
    '#0091EA'+t,//pend. sup. codif.	celeste
    '#4CAF50'+t,//finalizado ok		verde
    '#C5E1A5'+t,//finalizado c/inc	verde claro
    '#CA2C92'+t,//
    '#ca2cb8'+t,//
    '#8d1f81'+t,//
    '#ff9bf3'+t,//
    '#d6bfff'+t,//
    '#ad80ff'+t,//
];